import { SecondaryNavigation } from "@george-labs.com/design-system"
import { useNotifications } from "../../app/hooks"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import "./Sidebar.css"

const Sidebar = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const notifications = useNotifications()
  const unread = notifications.filter((i) => !i.read).length

  return (
    <SecondaryNavigation
      aria-label="Secondary"
      selectedItem={globalThis.location.href.includes("profile") ? 0 : 1}
      items={[
        {
          label: t("profile.title"),
          href: "",
          onClick: () => {
            navigate("/profile")
          },
        },
        {
          label: t("notifications.title"),
          href: "",
          onClick: () => {
            navigate("/notifications")
          },
          className: "notifications",
          pill: unread,
        },
      ]}
    />
  )
}

export default Sidebar
